<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="{ showStatus: true }"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'VxeInput',events:{click:({row})=>selectPositionType(row)}}" field="positionType.name" title="business.label.positionType"/>
      <vxe-column :cell-render="{name:'VxeInput',events:{click:({row})=>selectStorageRoom(row)}}" field="storageRoom.name" title="business.label.storageRoomName"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="visualized" title="business.label.visualized" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <field-modal ref="positionTypeModal" :no="'POSITION_TYPE'" :show-value="false" :title="$t('business.label.positionType')" @change="(rlt,row)=>row.positionType=changePositionType(rlt[0])"/>
    <storage-room-modal ref="storageRoomModal" @change="(rlt,row)=>row.storageRoom=changeStorageRoom(rlt[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, saveAll } from '@/api/Api'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { SeedingPositionConfig } from '@/api/dto/config/SeedingPositionConfig'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { StorageRoom } from '@/api/dto/common/StorageRoom'

export default {
  name: 'SeedingPositionConfig',
  components: { FieldModal, StorageRoomModal },
  data() {
    return {
      loading: false,
      data: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      contentSize: 0,
      page: 1,
      size: 20,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        'positionType.name': [
          { required: true, type: 'string', message: '位置类型不能为空' }
        ]
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    selectPositionType(row) {
      this.$refs.positionTypeModal.open({ available: true }, row)
    },
    changePositionType(data) {
      return new Dictionary(data)
    },
    selectStorageRoom(row) {
      this.$refs.storageRoomModal.open({ available: true, physical: true }, row)
    },
    changeStorageRoom(data) {
      return new StorageRoom(data)
    },
    refresh() {
      this.loading = true
      findAll('seedingPositionConfigFactory', {}, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new SeedingPositionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.data.push(new SeedingPositionConfig())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('seedingPositionConfigPersister', saveData).then(res => {
          if (res.success) {
            this.refresh()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>